var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4826_74339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.3434 8.02246V22.1351C48.3434 24.0487 48.3434 25.0054 48.7158 25.7363C49.0434 26.3792 49.5661 26.9018 50.209 27.2294C50.9398 27.6018 51.8966 27.6018 53.8101 27.6018H67.9228M55.1768 44.6849H27.8434M32.1768 58.3516H27.8434M34.6768 31.0182H27.8434M48.3434 7.10156H30.5768C24.8362 7.10156 21.966 7.10156 19.7734 8.21875C17.8447 9.20145 16.2766 10.7695 15.2939 12.6982C14.1768 14.8908 14.1768 17.761 14.1768 23.5016V59.0349C14.1768 64.7754 14.1768 67.6457 15.2939 69.8383C16.2766 71.767 17.8447 73.335 19.7734 74.3177C21.966 75.4349 24.8362 75.4349 30.5768 75.4349H52.4434C58.184 75.4349 61.0542 75.4349 63.2468 74.3177C65.1755 73.335 66.7435 71.767 67.7262 69.8383C68.8434 67.6457 68.8434 64.7754 68.8434 59.0349V27.6016L48.3434 7.10156Z",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4826_74339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "white",
    transform: "translate(0.510254 0.269531)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.1b0bd1b85f3b7e01c9a4286c0d86ae0f.svg";
export { ForwardRef as ReactComponent };